import Cookies from 'universal-cookie';

import useSetCookieAndRefresh from './andRefresh';
import CookieName from './name';

function setCookie(name: CookieName, token?: string | null) {
  const cookies = new Cookies();

  const env = process.env.NODE_ENV ?? 'production';

  return cookies.set(name, token, {
    maxAge: 30 * 24 * 60 * 60 * 1000,
    path: '/',
    secure: env !== 'development',
  });
}

export default setCookie;
export { CookieName, useSetCookieAndRefresh };
